export class Role {
    constructor(
      public id: string,
      public name: string,
      public order: number,
      public type: string,
      public visibleToMobile: boolean,
      public invisibleInClass: boolean,
      public canHaveChildren: boolean,
      public canHaveMultipleGroups: boolean,
      public canEditClasses: boolean,
      public preventActivationOfUsers: boolean,
      public canEditCategories: boolean,
      public canSeeTemplates: boolean,
      public canSelectIfUsersCanReply: boolean,
      public canSeeFormResults: boolean,
      public notifyWhenFormClass: boolean,
      public notifyWhenClassBook: boolean,
      public notifyWhenForm: boolean,
      public canEditUserFields: boolean,
      public dontShowCategories: boolean,
      public outOfOffice: boolean,
      public canMessageAllGroups: boolean,
      public disableAbsence: boolean,
      public enableQuickAnswers: boolean,
      public disableInFormDropdown: boolean,
      public roles: any[],
      public rolesAll: any[],
      public description?: string,
    ) { }
  }



// WEBPACK FOOTER //
// ./src/app/settings/roles/shared/role.model.ts